import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Route,
  BrowserRouter as Router,
  Routes
} from 'react-router-dom';

import {
  academyInfo,
  getMenuAcademy,
  getMetadataAcademy
} from 'store/academy-actions';
import { getUserInSession } from 'store/user-actions';

import Layout from './components/Layout/Layout';

import Home from './Pages/Home/Home';
import Login from './Pages/Login/Login';
import Register from './Pages/Register/Register';
import RecoverAccount from './Pages/RecoverAccount/RecoverAccount';
import Course from './Pages/Course/Course';
import Lesson from './Pages/Lesson/Lesson';
import NoAccessAcademy from 'Pages/NoAccessAcademy/NoAccessAcademy';
import DisabledAcademy from 'Pages/DisabledAcademy/DisabledAcademy';
import { setLinkLtik } from 'constants/LTIData';

const searchParams = new URLSearchParams(window.location.search);
const ltik = searchParams.get('ltik');
setLinkLtik(ltik);

let isInitial = true;

const url = window.location.pathname.split('/');

function App() {
  const dispatch = useDispatch();
  const dataAcademy = useSelector(state => state.academyInfo);
  const dataUser = useSelector(state => state.userInfo);

  useEffect(() => {
    dispatch(academyInfo(url[1]));
  }, [dispatch]);

  useEffect(() => {
    if (isInitial) {
      isInitial = false;
      return;
    }
    dispatch(getMenuAcademy(dataAcademy.data.idAcademy));
    dispatch(getUserInSession(dataAcademy.data.idAcademy));
  }, [dataAcademy.data, dispatch]);

  useEffect(() => {
    if (dataUser.data.systemDate) {
      if (
        dataAcademy.data.isOpen === 0 &&
        url[2] !== 'disabled' &&
        url[2] !== 'c' &&
        url[2] !== 'login' &&
        url[2] !== 'register' &&
        url[2] !== 'recoverAccount' &&
        !dataUser.data.academyAdmin
      ) {
        window.location.href = `/${dataAcademy.data.shortName}/disabled`;
      } else if (
        url[2] !== 'login' &&
        url[2] !== 'register' &&
        url[2] !== 'recoverAccount' &&
        !dataUser.data.usuario &&
        dataAcademy.data.productType === 2
      ) {
        window.location.href = `/${dataAcademy.data.shortName}/login`;
      }
    } else if (dataAcademy.data.shortName) {
      if (
        dataUser.data.limited &&
        dataUser.data.usuario &&
        url[2] !== 'access' &&
        dataAcademy.data.productType === 2
      ) {
        window.location.href = `/${dataAcademy.data.shortName}/access`;
      }
    }
    if (dataUser.data.usuario) {
      dispatch(getMetadataAcademy(dataAcademy.data.idAcademy));
    }
  }, [dataAcademy.data, dataUser.data]);

  return (
    <Router basename={`/${url[1]}`}>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/a" element={<Home />} />
          <Route path="/lp" element={<Home />} />
          <Route
            exact
            path="/search/:textSearch"
            element={<Home />}
          />
          <Route
            exact
            path="/a/search/:textSearch"
            element={<Home />}
          />
          <Route exact path="/login" element={<Login />} />
          <Route
            exact
            path="/access"
            element={<NoAccessAcademy />}
          />
          <Route exact path="/register" element={<Register />} />
          <Route
            exact
            path="/recoverAccount"
            element={<RecoverAccount />}
          />
          <Route exact path="/c/:idCourse" element={<Course />} />
          <Route exact path="/a/c/:idCourse" element={<Course />} />
          <Route
            exact
            path="/course/:idCourse"
            element={<Course />}
          />
          <Route
            exact
            path="/f/:idCourse/:idLesson"
            element={<Lesson />}
          />
          <Route
            exact
            path="/q/:idCourse/:idLesson"
            element={<Lesson />}
          />
          <Route
            exact
            path="/ac/:idCourse/:idLesson"
            element={<Lesson />}
          />
          <Route
            exact
            path="/lesson/:idCourse/:idLesson"
            element={<Lesson />}
          />
          <Route
            exact
            path="/aud/:idCourse/:idLesson"
            element={<Lesson />}
          />
          <Route
            exact
            path="/coe/:idCourse/:idLesson"
            element={<Lesson />}
          />
          <Route
            exact
            path="/a/f/:idCourse/:idLesson"
            element={<Lesson />}
          />
          <Route
            exact
            path="/a/lesson/:idCourse/:idLesson"
            element={<Lesson />}
          />
          <Route
            exact
            path="/a/aud/:idCourse/:idLesson"
            element={<Lesson />}
          />
          <Route
            exact
            path="/a/q/:idCourse/:idLesson"
            element={<Lesson />}
          />
          <Route
            exact
            path="/a/ac/:idCourse/:idLesson"
            element={<Lesson />}
          />
          <Route
            exact
            path="/a/coe/:idCourse/:idLesson"
            element={<Lesson />}
          />
          <Route
            exact
            path="/course/f/:idCourse/:idLesson"
            element={<Lesson />}
          />
          <Route
            exact
            path="/course/lesson/:idCourse/:idLesson"
            element={<Lesson />}
          />
          <Route
            exact
            path="/course/aud/:idCourse/:idLesson"
            element={<Lesson />}
          />
          <Route
            exact
            path="/course/q/:idCourse/:idLesson"
            element={<Lesson />}
          />
          <Route
            exact
            path="/course/ac/:idCourse/:idLesson"
            element={<Lesson />}
          />
          <Route
            exact
            path="/course/coe/:idCourse/:idLesson"
            element={<Lesson />}
          />
          <Route
            exact
            path="/lp/f/:idCourse/:idLesson"
            element={<Lesson />}
          />
          <Route
            exact
            path="/lp/lesson/:idCourse/:idLesson"
            element={<Lesson />}
          />
          <Route
            exact
            path="/lp/aud/:idCourse/:idLesson"
            element={<Lesson />}
          />
          <Route
            exact
            path="/lp/q/:idCourse/:idLesson"
            element={<Lesson />}
          />
          <Route
            exact
            path="/lp/ac/:idCourse/:idLesson"
            element={<Lesson />}
          />
          <Route
            exact
            path="/lp/coe/:idCourse/:idLesson"
            element={<Lesson />}
          />
          <Route path="/disabled" element={<DisabledAcademy />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
